import { jsx as i } from "react/jsx-runtime";
import { T as t } from "../../vendor--aJiswR_.js";
import "react";
import "../../theme/spacing.js";
import { omitStyleRenderProps as o } from "../../utils/omitStyleRenderProps/index.js";
import '../../assets/index45.css';const r = "_fieldDescription_14vc1_1", n = {
  fieldDescription: r
};
function m(e) {
  return e.children ? /* @__PURE__ */ i(
    t,
    {
      ...o(e),
      slot: "description",
      elementType: "span",
      className: n.fieldDescription,
      "data-component": "FieldDescription"
    }
  ) : null;
}
export {
  m as FieldDescription
};
//# sourceMappingURL=index.js.map
